import * as m from '@/store/modules/fsm/messages';
export {m};

import login from './login/index';
import welcome from './welcome/index';
import pdfs from './pdfs/index';

import reports from './reports/index';
import cdas from './cdas/index';
import profile from './profile/index';
import contact from './contact/index';
import provider from './provider/index';
import providers from './providers/index';
import diagnosis from './diagnosis/index';
import medications from './medications/index';
import procedures from './procedures/index';
import vaccinations from './vaccinations/index';
import allergies from './allergies/index';
import watch from './watch/index';
import vitals from './vitals/index'
import vitalsGroup from './vitalsGroup/index'
import medical_reports from './medical_reports/index';
import health_records from './health_records/index';
import search from './search/index';
import uploadDeviceData from './uploadDeviceData/index';
import adminregister from './adminregister/index';
import directives from './directives/index';
import devices from './devices/index';
import notes from './notes/index';
import orders from './orders/index';
import currentdiag from './currentdiag/index'
import currentmed from './currentmed/index'
import currentproc from './currentproc/index'
import currentprov from './currentprov/index'
import nurses from './nurses/index'
import patientnurse from './patientnurse/index'
import myaccount from './myaccount/index'
import medadmin from './medadmin/index'
import cptbilling from './cptbilling/index'
import cpt from './cpt/index'

export default({tree,parent,api}) => {
  if(!tree)
  {
    api.addState('machineState')
  }
  let here = parent.machineState;
  login({tree,parent:here,api});
  welcome({tree,parent:here,api});
  pdfs({tree,parent:here,api});
  notes({tree,parent:here,api});
  orders({tree,parent:here,api});
  
  reports({tree,parent:here,api});
  cdas({tree,parent:here,api});
  profile({tree,parent:here,api});
  devices({tree,parent:here,api})
  contact({tree,parent:here,api});
  diagnosis({tree,parent:here,api});
  
  provider({tree,parent:here,api});
  providers({tree,parent:here,api});
  medications({tree,parent:here,api});
  procedures({tree,parent:here,api});
  vaccinations({tree,parent:here,api});
  allergies({tree,parent:here,api});
  watch({tree,parent:here,api});
  vitals({tree,parent:here,api})
  vitalsGroup({tree,parent:here,api})
  directives({tree,parent:here,api})

  currentdiag({tree,parent:here,api})
  currentmed({tree,parent:here,api})
  currentproc({tree,parent:here,api})
  currentprov({tree,parent:here,api})
  nurses({tree,parent:here,api})
  patientnurse({tree,parent:here,api})
  myaccount({tree,parent:here,api})
  medadmin({tree,parent:here,api})
  cptbilling({tree,parent:here,api})
  cpt({tree,parent:here,api})
  
  medical_reports({tree,parent:here,api});
  health_records({tree,parent:here,api});
  search({tree,parent:here,api});
  adminregister({tree,parent:here,api});

  uploadDeviceData({tree,parent:here,api});
};
